
export const KEYS_DATA = {
    Backquote: {ru:'ё', en:'`' , ruShift:'Ё', enShift:'~'},
    Digit1:{ru:'1', en:'1' , ruShift:'!', enShift:'!'},
    Digit2:{ru:'2', en:'2' , ruShift:'"', enShift:'@'},
    Digit3:{ru:'3', en:'3' , ruShift:'№', enShift:'#'},
    Digit4:{ru:'4', en:'4' , ruShift:';', enShift:'$'},
    Digit5:{ru:'5', en:'5' , ruShift:'%', enShift:'%'},
    Digit6:{ru:'6', en:'6' , ruShift:':', enShift:'^'},
    Digit7:{ru:'7', en:'7' , ruShift:'?', enShift:'&'},
    Digit8:{ru:'8', en:'8' , ruShift:'*', enShift:'*'},
    Digit9:{ru:'9', en:'9' , ruShift:'(', enShift:'('},
    Digit0:{ru:'0', en:'0' , ruShift:')', enShift:')'},
    Minus:{ru:'-', en:'-' , ruShift:'_', enShift:'_'},
    Equal:{ru:'=', en:'=' , ruShift:'+', enShift:'+'},
    BracketLeft:{ru:'х', en:'[' , ruShift:'Х', enShift:'{'}, 
    BracketRight:{ru:'ъ', en:']' , ruShift:'Ъ', enShift:'}'},
    Backslash:{ru:'\\', en:'\\' , ruShift:'/', enShift:'|'},
    Semicolon:{ru:'ж', en:';' , ruShift:'Ж', enShift:':'},
    Quote:{ru:'э', en:"'" , ruShift:'Э', enShift:'"'},
    Comma:{ru:'б', en:',' , ruShift:'Б', enShift:'<'}, 
    Period:{ru:'ю', en:'.' , ruShift:'Ю', enShift:'>'},
    Slash:{ru:'.', en:'/' , ruShift:',', enShift:'?'},
 }
    
export const  EN_KEY_LAYOUT = [
    "`", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0","-","=", "Backspace",
    "Tab", "q", "w", "e", "r", "t", "y", "u", "i", "o", "p","[","]","\\",
     "Caps", "a", "s", "d", "f", "g", "h", "j", "k", "l",";","'", "Enter",
     "Shift", "z", "x", "c", "v", "b", "n", "m", ",", ".", "?", "Shift",
     "Ctrl","Alt", "space","Alt","Ctr", ];
 export const  RU_KEY_LAYOUT = [
    "ё", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0","-","=", "Backspace",
    "Tab", "й", "ц", "у", "к", "е", "н", "г", "ш", "щ", "з","х","ъ","\\",
     "Caps", "ф", "ы", "в", "а", "п", "р", "о", "л", "д","ж","э", "Enter",
     "Shift", "я", "ч", "с", "м", "и", "т", "ь", "б", "ю", ".", "Shift",
     "Ctrl","Alt", "space","Alt","Ctr",];
export const CODE_KEY = ['Backquote', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Digit0', 'Minus', 'Equal', 'Backspace',
     'Tab', 'KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyT', 'KeyY', 'KeyU', 'KeyI', 'KeyO', 'KeyP', 'BracketLeft', 'BracketRight', 'Backslash',
      'CapsLock', 'KeyA', 'KeyS', 'KeyD', 'KeyF', 'KeyG', 'KeyH', 'KeyJ', 'KeyK', 'KeyL', 'Semicolon', 'Quote', 'Enter',
       'ShiftLeft', 'KeyZ', 'KeyX', 'KeyC', 'KeyV', 'KeyB', 'KeyN', 'KeyM', 'Comma', 'Period', 'Slash', 'ShiftRight',   
       'ControlLeft', 'AltLeft', 'Space', 'AltRight', 'ControlRight', ];
     